import { Box, IconButton, InputBase } from '@mui/material'
import { SxProps, styled } from '@mui/material/styles'
import { CloseIcon, SearchIcon } from '$common/icons'
import { t } from '$i18n'

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  width: '100%',
  boxSizing: 'border-box',
  padding: '4px 10px 3px',
  borderRadius: 20,

  caretColor: theme.palette.primary500,
  backgroundColor: theme.palette.neutral100,
  ...theme.typography.titleRegular,

  '& ::placeholder': {
    color: theme.palette.neutral500,
  },
  border: `2px solid transparent`,
  '&.Mui-focused': {
    backgroundColor: theme.palette.white,
    borderColor: theme.palette.primary300,
    padding: '4px 10px 3px',
  },
  '&.Mui-error': {
    borderColor: theme.palette.error.main,
  },
}))

const StyledSearchIcon = styled(SearchIcon)`
  color: ${({ theme }) => theme.palette.neutral500};
  margin-left: 10px;
`

const Container = styled(Box)`
  background-color: white;
  box-sizing: border-box;
  padding: 10px 20px 5px;
`

export function SearchInput({
  query,
  onQueryChange,
  disabled,
  placeholder,
  sx,
  className,
  startAdornment,
}: {
  query: string
  onQueryChange: (text: string) => unknown
  disabled?: boolean
  placeholder?: string
  sx?: SxProps
  className?: string
  startAdornment?: React.ReactNode
}) {
  return (
    <Container sx={sx} className={className}>
      <StyledInputBase
        disabled={disabled}
        value={query}
        placeholder={placeholder || t('common.search')}
        startAdornment={startAdornment ?? <StyledSearchIcon />}
        endAdornment={
          query && (
            <IconButton
              onClick={() => onQueryChange('')}
              sx={{ width: '24px', height: '24px' }}
            >
              <CloseIcon
                sx={{ color: 'neutral500', width: '20px', height: '20px' }}
              />
            </IconButton>
          )
        }
        onChange={({ target: { value } }) => onQueryChange(value)}
      />
    </Container>
  )
}

SearchInput.defaultProps = {
  disabled: false,
  placeholder: '',
}
